const reduceStringByWordsSeparatedByComma = str =>
  str.split(",").slice(0, 3).join(",") + "..."

export { reduceStringByWordsSeparatedByComma }
